module.exports = __webpack_public_path__ + "assets/img/36_500_big.ca91aa19.jpg";